import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import {ActivatedRoute, Router} from '@angular/router';

import { NetworkHelperService } from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, GENERALES} from '../../../_config/strings';
import {Subject} from 'rxjs/Subject';
import * as moment from 'moment';


@Component({
  selector: 'app-control-interno',
  templateUrl: './control-interno.component.html',
  styleUrls: ['./control-interno.component.scss']
})
export class ControlInternoComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  GENERALES: any;
  // array´s
  arrayIndicador = [];

  constructor(
    private route: ActivatedRoute,
    private network: NetworkHelperService,
    private ruta: Router,
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.GENERALES = GENERALES;
  }

  ngOnInit() {
    this.getIndicador();
  }

  getIndicador() {
    this.network.callSecureService(
      // url
      this.API.user.indicadores + '/' + this.API.user.controlInterno,
      // metodo
      'GET',
      null).subscribe((response: any) => {
        console.log(response);
        response.Mensaje.forEach(element => {
          // obtendremos la informacion con el moment lo que queremos
          let inicio = moment(element.fechaCreacion);
          let fin = moment(element.fechaAutorizacion);
          let duracion = moment.duration(fin.diff(inicio)).asMinutes();
          this.arrayIndicador.push({
            sucursal: element.sucursalNombre,
            nombre: element.nombre,
            analista: element.analista,
            fechaCreacion: element.fechaCreacion,
            concepto: element.concepto,
            autorizacion: element.autorizacion,
            fechaAutorizacion: element.fechaAutorizacion,
            tiempoRespuesta: duracion
          });
        });
        this.dtTrigger.next();
      }, err => {console.log(err)});

  }

  exportTableToExcel(tableID, filename = '') {
    console.log('entro');
    var downloadLink;
    var dataType = 'application/vnd.ms-excel';
    var tableSelect = document.getElementById(tableID);
    var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Specify file name
    filename = filename?filename+'.xls':'excel_data.xls';

    // Create download link element
    downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      var blob = new Blob(['ufeff', tableHTML], {
        type: dataType
      });
      navigator.msSaveOrOpenBlob( blob, filename);
    } else {
        // Create a link to the file
        downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
        // Setting the file name
        downloadLink.download = filename;
        // triggering the function
        downloadLink.click();
    }
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/indicadores/control-interno/control-interno.component.ts